import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel() {
    const { useLang } = useGlobal();
    const { t } = useLang('100wrigidsolarpanel');

    const bannerData = [
        {
            bgImgs: ['/media/100w_rigid/pc/banner.webp', '/media/100w_rigid/pc/banner.jpg'],
            title: t('solarpanels_100w.title'),
            des: t('solarpanels_100w.des'),
        },
    ];

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ isShowLogo: false, theme: 'black' }} />
            </div>
            <Content />
        </div>
    );
}
